@if (erRedigeringsmodus()) {
  <medlem-rediger [medlem]="medlem()"
                  [gruppe]="gruppe()"
                  (vedLagret)="vedRedigeringFerdig()"
                  (vedAvbryt)="vedRedigeringFerdig()"/>

} @else if (medlem().anonymisert) {
  <!-- medlemsinfo - anonymisert medlem -->
  <kort [id]="medlem().id" #kort>
    <medlem-informasjon [medlem]="medlem()" avatarStil="stor"/>
  </kort>

} @else {
  <!-- medlemsinfo - ikke-anonymisert medlem -->
  <!-- Merk at vi også har en ref til kort i komponentklassen (MedlemKortKomponent.kortKomp),
  men denne vil ikke være initialisert før AfterViewInit, har derfor også en lokal ref her (#kort)
  slik at vi har tilgang ved initiell uttegning -->
  <kort [id]="medlem().id" #kort>
    <medlem-informasjon [medlem]="medlem()" [avatarStil]="kort.erAktiv() ? 'xxstor' : 'stor'"/>

    @if (kort.erAktiv()) {
      <ramme-med-tittel [tittel]="'Roller'|translate" class="rolleperioder">
        <ramme-innhold>
          @for (rolle of medlem().aktiveMedlemsroller; track rolle.id) {
            <div class="rolleperiode e2e-rolleperiode">
              <div class="tittel e2e-tittel">{{ rolle.tittel }}</div>
              <div class="periode e2e-periode">{{ rolle.periode | datoperiodeutentid }}</div>
            </div>
          }

          @if (medlem().aktiveMedlemsroller.length == 0) {
            @if (visRedigerKnapp()) {
              <div class="ingen_roller">
                <a (click)="rediger()" class="ingen_roller">{{ 'Rediger'|translate }}</a> {{ 'for å legge til en rolle'|translate }}
              </div>
            } @else {
              <div class="ingen_roller">{{ 'Ingen roller registrert'|translate }}</div>
            }
          }

          @if (medlem().inaktiveMedlemsroller.length > 0 && !visInaktiveMedlemsroller()) {
            <a (click)="visInaktiveMedlemsroller.set(true)">{{ 'Vis {antall} inaktive roller'|translate: {antall: medlem().inaktiveMedlemsroller.length} }}</a>
          }

          @if (visInaktiveMedlemsroller()) {
            <a (click)="visInaktiveMedlemsroller.set(false)">{{ 'Skjul {antall} inaktive roller'|translate: {antall: medlem().inaktiveMedlemsroller.length} }}</a>

            @for (rolle of medlem().inaktiveMedlemsroller; track rolle.id) {
              <div class="rolleperiode">
                <div class="tittel">{{ rolle.tittel }}</div>
                <div class="periode">{{ rolle.periode | datoperiodeutentid }}</div>
              </div>
            }
          }
        </ramme-innhold>
      </ramme-med-tittel>

      <ramme-med-tittel [tittel]="'Brukertilgang'|translate" class="tilgangsroller">
        <ramme-innhold>
          <div class="tilganger">
            @for (tilgang of tilgangsroller(); track tilgang.rolle; let erSiste = $last) {
              <span [matTooltip]="tilgang.subtittel(enumOversettelser)">
                {{ tilgang.tittel(enumOversettelser) }}@if (!erSiste) {,}
              </span>
            }
          </div>
        </ramme-innhold>
      </ramme-med-tittel>
    }
    <kort-handlinger>
      @if (kort.erAktiv()) {
        <div class="knappejustering-luftMellom">
          <button mat-button type="button" (click)="visMindre()">
            <mat-icon class="material-symbols-fet">more_vert</mat-icon>
            {{ "Vis mindre"|translate }}
          </button>
          <div class="knappejustering-venstre">
            @if (visRedigerKnapp()) {
              <button mat-button type="button" (click)="rediger()" class="e2e-rediger">
                <mat-icon>edit</mat-icon>
                {{ "Rediger"|translate }}
              </button>
            }
            @if (visStengTilgangKnapp()) {
              <button mat-button type="button" (click)="stengTilgang()" [disabled]="erInnloggetBruker()" class="e2e-stengtilgang">
                <mat-icon fontSet="ion-key" class="mat-icon--ionic-ikon"/>
                {{ "Steng tilgang"|translate }}
              </button>
            }
            @if (visGjenaapneTilgangKnapp()) {
              <button mat-button color="primary" type="button" (click)="gjenaapneTilgang()" class="e2e-gjenaapnetilgang">
                <mat-icon fontSet="ion-ios-trash-outline" class="mat-icon--ionic-ikon"/>
                {{ "Gjenåpne tilgang"|translate }}
              </button>
              <button mat-button type="button" color="warn" (click)="anonymiser()" class="e2e-deaktiverpermanent">
                <mat-icon>no_accounts</mat-icon>
                {{ "Deaktiver permanent"|translate }}
              </button>
            }
          </div>
        </div>
        @if (redigeringMulig() && medlem().medlemstatus == medlemstatuser.normal_tilgang) {
          <tips forsinketVisning="true" data-testid="endre-møtedeltakelse-tips">
            <span>{{ 'Du kan endre hvilke medlemmer som skal delta på møter som standard i'|translate }}</span>
            <a class="klikkbar" (click)="gaaTilMoetemal()">{{ 'møtemalen'|translate }}</a>.
          </tips>
        }

      } @else {
        <button mat-button type="button" (click)="visMer()" class="e2e-vis-mer">
          <mat-icon class="material-symbols-fet">more_horiz</mat-icon>
          {{ "Vis mer"|translate }}
        </button>
      }

    </kort-handlinger>
  </kort>
}
